(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .factory('AppraisalOrderChangeRequestSearch', AppraisalOrderChangeRequestSearch);

    AppraisalOrderChangeRequestSearch.$inject = ['$resource'];

    function AppraisalOrderChangeRequestSearch($resource) {
        var resourceUrl =  'api/_search/appraisal-order-change-requests/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
